import {DashboardLayout} from "../../layout/dashboard.layout";
import {useTranslation} from "react-i18next";
import {DASHBOARD, GROUPS_CREATE, GROUPS_EDIT} from "../../../routes/frontend.routes";
import {createColumnHelper} from "@tanstack/react-table";
import {IndeterminateCheckbox} from "../../../../app-common/components/input/checkbox.intermediate";
import React from "react";
import {TableComponent} from "../../../../app-common/components/table/table";
import {GROUP_BULK_DELETE, GROUP_LIST, SENDER_NAME_BULK_DELETE} from "../../../../api/routing/routes/backend.app";
import {Group} from "../../../../api/model/group";
import {Link} from "react-router-dom";
import moment from "moment/moment";
import {ConfirmAlert} from "../../../../app-common/components/confirm/confirm.alert";
import {jsonRequest} from "../../../../api/request/request";
import {HttpException, NotFoundException} from "../../../../lib/http/exception/http.exception";
import {useAlert} from "react-alert";

export const Groups = () => {
  const {t} = useTranslation();

  const columnHelper = createColumnHelper<Group>();

  const columns = [
    columnHelper.accessor('uuid', {
      enableSorting: false,
      header: ({table}) => (
        <div className="px-1">
          <IndeterminateCheckbox
            {...{
              checked: table.getIsAllRowsSelected(),
              indeterminate: table.getIsSomeRowsSelected(),
              onChange: table.getToggleAllRowsSelectedHandler(),
            }}
          />
        </div>
      ),
      cell: ({row}) => (
        <div className="px-1">
          <IndeterminateCheckbox
            {...{
              checked: row.getIsSelected(),
              indeterminate: row.getIsSomeSelected(),
              onChange: row.getToggleSelectedHandler(),
            }}
          />
        </div>
      )
    }),
    columnHelper.accessor('name', {
      header: () => t('Name'),
    }),
    columnHelper.accessor('description', {
      header: () => t('Description'),
    }),
    columnHelper.accessor('isActive', {
      header: () => t('Active?'),
      cell: info => info.getValue() ? t('Yes') : t('No')
    }),
    columnHelper.accessor('updatedAt.datetime', {
      header: () => t('Updated at'),
      cell: info => moment(info.getValue()).format('lll'),
    }),
    columnHelper.accessor('uuid', {
      header: () => t('Actions'),
      cell: info => (
        <Link to={GROUPS_EDIT.replace(':id', info.getValue())} className="btn btn-primary">
          {t('Update')}
        </Link>
      )
    })
  ];

  return (
    <DashboardLayout
      title="Groups"
      breadCrumbs={[
        {title: t('Dashboard'), link: DASHBOARD},
        {title: t('Groups'), current: true}
      ]}
      buttons={[
        <Link to={GROUPS_CREATE} className="float-end btn btn-primary">{t('Create')}</Link>
      ]}
    >
      <div className="row">
        <div className="col-12">
          <div className="card">
            <div className="card-body">
              <h5 className="card-title">
                {t('List')}
              </h5>
              <TableComponent columns={columns} url={GROUP_LIST} selectionButtons={[{
                title: <i className="bi bi-trash3"></i>,
                type: 'bulkDelete',
                className: 'btn btn-danger',
                url: GROUP_BULK_DELETE
              }]}/>
            </div>
          </div>
        </div>
      </div>
    </DashboardLayout>
  );
};
